import { TESTIMONIALS_DATA } from "../../../mocks/aegis-data";

export default function TestimonialsSection() {
  const featured = TESTIMONIALS_DATA[1];
  const supporting = [TESTIMONIALS_DATA[0], TESTIMONIALS_DATA[2]];

  return (
    <section className="bg-aegisDark py-28 overflow-hidden relative">
      {/* Subtle vertical gold line */}
      <div className="absolute top-0 right-0 w-px h-full bg-gradient-to-b from-transparent via-aegisGold/15 to-transparent" />
      <div className="absolute top-0 left-0 w-px h-full bg-gradient-to-b from-transparent via-aegisGold/15 to-transparent" />

      <div className="max-w-7xl mx-auto px-8">
        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-4 mb-5">
              <div className="h-px w-10 bg-aegisGold" />
              <span className="font-inter text-xs tracking-[0.2em] uppercase text-aegisGold">Client Stories</span>
            </div>
            <h2 className="font-cormorant font-semibold text-white leading-[1.1]" style={{ fontSize: "clamp(2.2rem, 3.5vw, 3.4rem)" }}>
              What Our Clients Say
            </h2>
          </div>
          <div className="flex flex-col items-end gap-2 flex-shrink-0">
            <div className="flex gap-1">
              {[1,2,3,4,5].map(i => (
                <span key={i} className="text-aegisGold text-xl">★</span>
              ))}
            </div>
            <span className="font-inter text-white/35 text-sm">5.0 · Verified Client Reviews</span>
          </div>
        </div>

        {/* Featured testimonial */}
        <div className="relative mb-4 border border-white/10 overflow-hidden">
          {/* Background gold texture */}
          <div className="absolute inset-0 bg-gradient-to-br from-aegisGold/5 to-transparent" />
          {/* Giant decorative quote */}
          <span className="absolute -top-6 left-6 font-cormorant text-[220px] leading-none text-aegisGold/8 select-none pointer-events-none" style={{ lineHeight: 1 }}>
            &ldquo;
          </span>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-0">
            {/* Left: author */}
            <div className="lg:col-span-3 p-10 lg:border-r border-white/10 flex flex-col justify-center">
              {/* Monogram */}
              <div className="w-20 h-20 flex items-center justify-center border border-aegisGold/30 mb-6">
                <span className="font-cormorant font-bold text-aegisGold text-4xl">
                  {featured.author.charAt(0)}
                </span>
              </div>
              <p className="font-inter font-semibold text-white text-base mb-1">{featured.author}</p>
              <p className="font-inter text-aegisMuted text-sm">{featured.location}</p>
              <div className="flex gap-0.5 mt-3">
                {[1,2,3,4,5].map(i => <span key={i} className="text-aegisGold text-sm">★</span>)}
              </div>
              <div className="w-10 h-0.5 bg-aegisGold mt-5" />
              <span className="font-inter text-xs tracking-widest uppercase text-aegisGold mt-4">
                Sarasota, FL
              </span>
            </div>

            {/* Right: quote */}
            <div className="lg:col-span-9 p-10 lg:p-14 flex items-center">
              <p className="font-cormorant italic text-white/90 leading-relaxed" style={{ fontSize: "clamp(1.5rem, 2.5vw, 2.2rem)" }}>
                &ldquo;{featured.quote}&rdquo;
              </p>
            </div>
          </div>
        </div>

        {/* Supporting cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {supporting.map((t) => (
            <div key={t.id} className="group relative bg-white/4 border border-white/8 overflow-hidden hover:border-aegisGold/35 transition-all duration-300">
              {/* Subtle quote mark */}
              <span className="absolute top-3 right-5 font-cormorant text-8xl leading-none text-aegisGold/8 select-none pointer-events-none">
                &ldquo;
              </span>

              <div className="p-8 relative z-10">
                {/* Stars */}
                <div className="flex gap-0.5 mb-5">
                  {[1,2,3,4,5].map(i => <span key={i} className="text-aegisGold text-sm">★</span>)}
                </div>

                <p className="font-cormorant italic text-white/80 text-xl leading-relaxed mb-7 pr-6">
                  &ldquo;{t.quote}&rdquo;
                </p>

                <div className="flex items-center gap-4 pt-5 border-t border-white/8">
                  <div className="w-10 h-10 flex items-center justify-center border border-aegisGold/25 group-hover:border-aegisGold/50 flex-shrink-0 transition-colors duration-300">
                    <span className="font-cormorant font-bold text-aegisGold text-lg">
                      {t.author.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-inter font-semibold text-white text-sm">{t.author}</p>
                    <p className="font-inter text-aegisMuted text-xs mt-0.5">{t.location}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* After-testimonials CTA */}
        <div className="mt-12 bg-aegisGold/10 border border-aegisGold/20 px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="font-cormorant italic text-white/60 text-lg">"Real clients. Real projects. Real results in Sarasota."</p>
          </div>
          <a
            href="tel:9414870007"
            className="inline-flex items-center gap-3 border border-aegisGold text-aegisGold font-inter font-semibold text-sm tracking-widest uppercase px-8 py-3.5 whitespace-nowrap cursor-pointer hover:bg-aegisGold hover:text-white transition-all duration-300"
          >
            <i className="ri-phone-line" />
            Join Our Clients
          </a>
        </div>
      </div>
    </section>
  );
}
